import React, { useState } from 'react';
import QRCode from 'qrcode.react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';

const QrCodeComponent = (props) => {
  const { value } = props; // Desestruture a propriedade para acessar o valor

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value)
    setCopied(true);
    setTimeout(() => {
        setCopied(false);
        }, 3000);
  };

  if(!value) return (<div></div>);

  return (
    <div style={{ alignItems: 'center', textAlign: 'center' }}>
      <QRCode value={value} style={{ height: '200px', width: '200px', margin: '24px' }} />
      <p style={{ fontSize: 14, textAlign: 'center', marginBottom: 8, marginTop: 8, fontFamily: 'Raleway' }}>Escaneie o QRCode para efetuar o pagamento</p>
      <p style={{ fontSize: 14, textAlign: 'center', marginBottom: 8, marginTop: 8, fontFamily: 'Raleway' }}>Ou copie o código pix:</p>
      <IconButton  onClick={handleCopy} style={{ margin: 8 }}>
        <ContentCopyIcon />
      </IconButton>
      {copied && <p style={{ fontSize: 14, fontFamily: 'Raleway', color: 'green' }}>Código copiado!</p>}
    </div>
  );
};

export default QrCodeComponent;
